import React, { useState } from 'react';
import AdminUsuarios from './AdminUsuarios';
import InformeAdmin from './InformeAdmin';
import LegalInfo from './LegalInfo';
import PanelModificacionFichajes from './PanelModificacionFichajes';
import ConfiguracionEmpresa from './ConfiguracionEmpresa';
import { API_BASE } from '../api';

function PanelAdmin({ token }) {
  const [view, setView] = useState('');
  const [usuario, setUsuario] = useState(null);

  React.useEffect(() => {
    async function fetchUsuario() {
      try {
        const res = await fetch(`${API_BASE}/api/auth/me`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const data = await res.json();
        setUsuario(data);
      } catch {
        setUsuario(null);
      }
    }
    fetchUsuario();
  }, [token]);

  const fontFamily = 'Quicksand, Montserrat, Arial, sans-serif';

  const tabs = [
    { id: 'crear', label: 'Gestión de usuarios', icon: '👥', color: '#388e3c', gradient: 'linear-gradient(135deg, #388e3c 0%, #66bb6a 100%)' },
    { id: 'fichajes', label: 'Informes', icon: '📊', color: '#1976d2', gradient: 'linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)' },
    ...(usuario?.allowModify ? [{ id: 'modificar', label: 'Modificar fichajes', icon: '✏️', color: '#f57c00', gradient: 'linear-gradient(135deg, #f57c00 0%, #ffb74d 100%)' }] : []),
    { id: 'configuracion', label: 'Configuración empresa', icon: '⚙️', color: '#6d28d9', gradient: 'linear-gradient(135deg, #6d28d9 0%, #a78bfa 100%)' },
  ];

  return (
    <div style={{ maxWidth: 900, margin: '1em auto', fontFamily, padding: '0 0.6em', boxSizing: 'border-box' }}>
      <style>{`
        @keyframes paFadeIn { from { opacity: 0; transform: translateY(16px); } to { opacity: 1; transform: translateY(0); } }
        .pa-tab { transition: all 0.22s cubic-bezier(.4,0,.2,1); }
        .pa-tab:hover { transform: translateY(-3px) scale(1.03); }
        .pa-tab-active { transform: translateY(-3px) scale(1.03); }
        .pa-view { animation: paFadeIn 0.35s cubic-bezier(.4,0,.2,1); }
        .pa-back-btn { transition: all 0.2s; }
        .pa-back-btn:hover { transform: translateY(-2px); }
        @media (max-width: 480px) {
          .pa-tabs-grid { grid-template-columns: repeat(2, 1fr) !important; gap: 0.65em !important; }
          .pa-tab { padding: 1em 0.9em !important; }
          .pa-tab span:first-child { font-size: 28px !important; }
          .pa-tab span:last-child { font-size: 0.92em !important; }
          .pa-header { padding: 1em 1em !important; }
          .pa-header-icon { font-size: 28px !important; }
          .pa-header-title { font-size: 1.1em !important; }
          .pa-section-header { padding: 0.7em 1em !important; margin-bottom: 0.8em !important; }
          .pa-back-btn { width: 100% !important; justify-content: center !important; }
        }
        @media (max-width: 360px) {
          .pa-tabs-grid { grid-template-columns: 1fr 1fr !important; }
          .pa-tab span:last-child { font-size: 0.82em !important; }
        }
      `}</style>

      {/* Cabecera del panel */}
      <div className="pa-header" style={{
        background: 'linear-gradient(135deg, rgba(25,118,210,0.07) 0%, rgba(66,165,245,0.10) 100%)',
        border: '2px solid rgba(25,118,210,0.15)',
        borderRadius: 20,
        padding: '1.2em 1.4em',
        marginBottom: '1.2em',
        display: 'flex',
        alignItems: 'center',
        gap: '0.8em'
      }}>
        <span className="pa-header-icon" style={{ fontSize: 38 }}>🛡️</span>
        <div>
          <div className="pa-header-title" style={{ fontWeight: 800, fontSize: '1.3em', color: '#1976d2' }}>Panel de Administración</div>
          {usuario && (
            <div style={{ color: '#64748b', fontSize: '0.9em', marginTop: '0.2em' }}>
              {usuario.nombre} {usuario.apellidos} · <span style={{ color: '#1976d2', fontWeight: 700 }}>Administrador</span>
            </div>
          )}
        </div>
      </div>

      {/* Tabs de navegación */}
      {view === '' && (
        <div className="pa-tabs-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 200px), 1fr))', gap: '0.9em', marginBottom: '1.2em' }}>
          {tabs.map(tab => (
            <button
              key={tab.id}
              className="pa-tab"
              onClick={() => setView(tab.id)}
              style={{
                display: 'flex', flexDirection: 'column', alignItems: 'flex-start',
                gap: '0.5em', padding: '1.2em 1.3em',
                borderRadius: 18,
                border: '3px solid transparent',
                background: `linear-gradient(white, white) padding-box, ${tab.gradient} border-box`,
                cursor: 'pointer', fontFamily,
                boxShadow: '0 4px 16px rgba(0,0,0,0.07)',
                textAlign: 'left', width: '100%'
              }}
            >
              <span style={{ fontSize: 32 }}>{tab.icon}</span>
              <span style={{ fontWeight: 800, fontSize: '1.0em', color: tab.color, lineHeight: 1.3 }}>{tab.label}</span>
            </button>
          ))}
        </div>
      )}

      {/* Vistas */}
      {view !== '' && (
        <div className="pa-view">
          {/* Botón volver */}
          <button
            className="pa-back-btn"
            onClick={() => setView('')}
            style={{
              display: 'inline-flex', alignItems: 'center', gap: '0.5em',
              padding: '0.7em 1.4em', borderRadius: 10, marginBottom: '1em',
              border: '2px solid #cbd5e1', background: '#f8fafc',
              color: '#475569', fontWeight: 700, fontFamily, fontSize: '1rem',
              cursor: 'pointer', boxShadow: '0 2px 8px rgba(0,0,0,0.06)'
            }}
          >
            ← Volver al panel
          </button>

          {/* Cabecera de la sección activa */}
          {(() => {
            const tab = tabs.find(t => t.id === view);
            return tab ? (
              <div className="pa-section-header" style={{
                display: 'flex', alignItems: 'center', gap: '0.7em',
                padding: '0.85em 1.2em', borderRadius: 14, marginBottom: '1em',
                background: `linear-gradient(135deg, rgba(0,0,0,0.03) 0%, rgba(0,0,0,0.05) 100%)`,
                border: `2px solid ${tab.color}22`
              }}>
                <span style={{ fontSize: 24 }}>{tab.icon}</span>
                <span style={{ fontWeight: 800, fontSize: '1.1em', color: tab.color }}>{tab.label}</span>
              </div>
            ) : null;
          })()}

          {view === 'crear' && <AdminUsuarios token={token} />}
          {view === 'fichajes' && <InformeAdmin token={token} />}
          {view === 'modificar' && usuario?.allowModify && <PanelModificacionFichajes token={token} usuario={usuario} />}
          {view === 'configuracion' && <ConfiguracionEmpresa token={token} />}
        </div>
      )}

      <LegalInfo style={{ marginTop: '1.5em', fontSize: '0.9em' }} />
    </div>
  );
}

export default PanelAdmin;
